export enum DIALOG_TYPES {
  CREATE_FOLDER,
  MAKE_BUCKET_PUBLIC,
  MAKE_BUCKET_PRIVATE,
  SHOW_BUCKET_URL,
  DELETE_BUCKET,
  DOWNLOAD_FILE,
  SHOW_FILE_URL,
  GET_SIGNED_DOWNLOADING_LINK,
  DELETE_FILES,
  DELETE_FILE,
  DELETE_FILE_ALL_VERSIONS,
  SET_LIFECYCLE_RULE,
  DELETE_LIFECYCLE_RULE,
  ENABLE_VERSIONING,
  SUSPEND_VERSIONING
  // FLAT_LIST_INFO
}
